import { render, staticRenderFns } from "./PersonalCenterApp.vue?vue&type=template&id=5a52dd23&scoped=true&"
import script from "./PersonalCenterApp.vue?vue&type=script&lang=js&"
export * from "./PersonalCenterApp.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCenterApp.vue?vue&type=style&index=0&id=5a52dd23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52dd23",
  null
  
)

export default component.exports